"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutGridRowEdit = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2023 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_grid_system_1 = require("react-grid-system");
var reverse_1 = tslib_1.__importDefault(require("lodash/fp/reverse"));
var dragAndDrop_1 = require("../../dragAndDrop");
var DashboardLayoutItem_1 = require("./DashboardLayoutItem");
var defaultItemKeyGetter = function (_a) {
    var item = _a.item;
    return item.index().toString();
};
function DashboardLayoutGridRowEdit(props) {
    var section = props.section, _a = props.itemKeyGetter, itemKeyGetter = _a === void 0 ? defaultItemKeyGetter : _a, gridRowRenderer = props.gridRowRenderer, itemRenderer = props.itemRenderer, widgetRenderer = props.widgetRenderer, getLayoutDimensions = props.getLayoutDimensions, screen = props.screen, items = props.items, renderMode = props.renderMode, itemsInRowsByIndex = props.itemsInRowsByIndex;
    var isDraggingWidget = dragAndDrop_1.useIsDraggingWidget();
    var rowItems = react_1.useMemo(function () {
        return items.map(function (item) { return (react_1.default.createElement(DashboardLayoutItem_1.DashboardLayoutItem, { key: itemKeyGetter({ item: item, screen: screen }), item: item, itemRenderer: itemRenderer, widgetRenderer: widgetRenderer, screen: screen })); });
    }, [itemKeyGetter, itemRenderer, items, screen, widgetRenderer]);
    var extendedRows = react_1.useMemo(function () {
        return isDraggingWidget
            ? rowItems
            : reverse_1.default(itemsInRowsByIndex).reduce(function (acc, _a) {
                var _b = tslib_1.__read(_a, 2), index = _b[0], itemsInRow = _b[1];
                return splice(acc, index + 1, 0, react_1.default.createElement(react_grid_system_1.Col, { xl: 12, key: "HeightResizerHotspot-" + index, style: { minHeight: 0 } },
                    react_1.default.createElement(dragAndDrop_1.HeightResizerHotspot, { key: "HeightResizerHotspot-" + index, screen: screen, getLayoutDimensions: getLayoutDimensions, section: section, items: itemsInRow })));
            }, rowItems);
    }, [isDraggingWidget, rowItems, itemsInRowsByIndex, screen, getLayoutDimensions, section]);
    return (react_1.default.createElement(react_grid_system_1.Row, { className: "gd-fluidlayout-row s-gd-fluid-layout-row" }, gridRowRenderer
        ? gridRowRenderer({
            children: extendedRows,
            screen: screen,
            section: section,
            items: items,
            renderMode: renderMode,
        })
        : extendedRows));
}
exports.DashboardLayoutGridRowEdit = DashboardLayoutGridRowEdit;
function splice(arr, start, deleteCount) {
    var addItem = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        addItem[_i - 3] = arguments[_i];
    }
    var result = [];
    if (start > 0) {
        result.push.apply(result, tslib_1.__spread(arr.slice(0, start)));
    }
    result.push.apply(result, tslib_1.__spread(addItem));
    var len = result.length - addItem.length;
    var count = deleteCount <= 0 ? len : len + deleteCount;
    if (arr[count]) {
        result.push.apply(result, tslib_1.__spread(arr.slice(count)));
    }
    return result;
}
//# sourceMappingURL=DashboardLayoutGridRowEdit.js.map